/**
 * EZTree 分支數據類（從 @dgreenheck/ez-tree 移植）
 */

import * as THREE from 'three'

export class Branch {
  origin: THREE.Vector3
  orientation: THREE.Euler
  length: number
  radius: number
  level: number
  sectionCount: number
  segmentCount: number

  constructor(
    origin = new THREE.Vector3(),
    orientation = new THREE.Euler(),
    length = 0,
    radius = 0,
    level = 0,
    sectionCount = 0,
    segmentCount = 0,
  ) {
    this.origin = origin.clone()
    this.orientation = orientation.clone()
    this.length = length
    this.radius = radius
    this.level = level
    this.sectionCount = sectionCount
    this.segmentCount = segmentCount
  }
}
